<template>
  <div>
    <!-- Dialog'u açan buton -->
    <!-- <v-btn color="primary" @click="dialog = true">
      Unvan Seç
    </v-btn> -->

    <!-- Dialog -->
    <!-- <v-dialog v-model="dialog" max-width="500px">
     
    </v-dialog>-->
    <v-card>
      <v-toolbar dark color="primary">

        <v-toolbar-title> Unvan Seçimi</v-toolbar-title>
        <v-spacer></v-spacer>

      </v-toolbar>
      <!-- <v-card-title class="headline">
          Unvan Seçimi
        </v-card-title> -->

      <v-card-text>
         <v-radio-group
              v-model="selectedType" 
              row
            >
              <v-radio v-for="type in types" v-bind:key="type.id"
                :label="type.name"
           
                :value="type.id"
              ></v-radio>
            
            </v-radio-group>
        <!-- Unvan seçimi için autocomplete -->
        <v-autocomplete v-model="selectedUnvan" :items="unvans" label="Unvan seçiniz" multiple
          clearable></v-autocomplete>

      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="primary" text @click="saveSelected">Seçilenleri Aktar</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import FilterUserService from '@/services/FilterUserService';

export default {
  data() {
    return {
      dialog: false,
      selectedUnvan: [],
      unvans: [
        "Dr.",
        "Prof.",
        "Av.",
        "Sn.",
        "Öğr. Gör.",
        "Doç. Dr.",
        "Yrd. Doç. Dr."
      ],
      selectedType:"akademik",
types:[{id:"akademik",name:"Akademik"},
  {id:"idari",name:"İdari"},
  {id:"",name:"Tümü"}
]

    };
  },
   watch: {
    selectedType(newValue, oldValue) {
       this.databind();

    }
  },
  mounted() {
    this.databind();
  },
  methods: {
    databind() {
      FilterUserService.listUnvanByTur(this.selectedType).then((result) => {
        console.log("listUnvan:",result.data);
        this.unvans = result.data.map((item) => item.name);
      }).catch((err) => {

      });

    },
    saveSelected() {
      // this.dialog = false;
      // Seçilen unvanı burada kullanabilirsiniz
      console.log("Seçilen unvan:", this.selectedUnvan);
      // Örneğin parent component'e emit edebilirsiniz
      this.$emit("selectedChange", this.selectedUnvan);
    },
    getValue() {
      return this.selectedUnvan;
    }
  }
};
</script>
